export default {
    publicSchool: {
        asthma: [
            'PUB_SCH_ASTHMA_TOTAL',
            'PUB_SCH_AGG_ASTHMA',
            'PUB_SCH_K3_ASTHMA',
            'PUB_SCH_K4_ASTHMA',
            'PUB_SCH_K_ASTHMA',
            'PUB_SCH_1_ASTHMA',
            'PUB_SCH_2_ASTHMA',
            'PUB_SCH_3_ASTHMA',
            'PUB_SCH_4_ASTHMA',
            'PUB_SCH_5_ASTHMA',
            'PUB_SCH_6_ASTHMA',
            'PUB_SCH_7_ASTHMA',
            'PUB_SCH_8_ASTHMA',
            'PUB_SCH_9_ASTHMA',
            'PUB_SCH_10_ASTHMA',
            'PUB_SCH_11_ASTHMA',
            'PUB_SCH_12_ASTHMA',
        ],
        type1: [
            'PUB_SCH_TYPE1_TOTAL',
            'PUB_SCH_AGG_TYPE1',
            'PUB_SCH_K3_TYPE1',
            'PUB_SCH_K4_TYPE1',
            'PUB_SCH_K_TYPE1',
            'PUB_SCH_1_TYPE1',
            'PUB_SCH_2_TYPE1',
            'PUB_SCH_3_TYPE1',
            'PUB_SCH_4_TYPE1',
            'PUB_SCH_5_TYPE1',
            'PUB_SCH_6_TYPE1',
            'PUB_SCH_7_TYPE1',
            'PUB_SCH_8_TYPE1',
            'PUB_SCH_9_TYPE1',
            'PUB_SCH_10_TYPE1',
            'PUB_SCH_11_TYPE1',
            'PUB_SCH_12_TYPE1',
        ],
        type2: [
            'PUB_SCH_TYPE2_TOTAL',
            'PUB_SCH_AGG_TYPE2',
            'PUB_SCH_K3_TYPE2',
            'PUB_SCH_K4_TYPE2',
            'PUB_SCH_K_TYPE2',
            'PUB_SCH_1_TYPE2',
            'PUB_SCH_2_TYPE2',
            'PUB_SCH_3_TYPE2',
            'PUB_SCH_4_TYPE2',
            'PUB_SCH_5_TYPE2',
            'PUB_SCH_6_TYPE2',
            'PUB_SCH_7_TYPE2',
            'PUB_SCH_8_TYPE2',
            'PUB_SCH_9_TYPE2',
            'PUB_SCH_10_TYPE2',
            'PUB_SCH_11_TYPE2',
            'PUB_SCH_12_TYPE2',
        ],
        seizure: [
            'PUB_SCH_SEIZURE_TOTAL',
            'PUB_SCH_AGG_SEIZURE',
            'PUB_SCH_K3_SEIZURE',
            'PUB_SCH_K4_SEIZURE',
            'PUB_SCH_K_SEIZURE',
            'PUB_SCH_1_SEIZURE',
            'PUB_SCH_2_SEIZURE',
            'PUB_SCH_3_SEIZURE',
            'PUB_SCH_4_SEIZURE',
            'PUB_SCH_5_SEIZURE',
            'PUB_SCH_6_SEIZURE',
            'PUB_SCH_7_SEIZURE',
            'PUB_SCH_8_SEIZURE',
            'PUB_SCH_9_SEIZURE',
            'PUB_SCH_10_SEIZURE',
            'PUB_SCH_11_SEIZURE',
            'PUB_SCH_12_SEIZURE',
        ],
        lta: [
            'PUB_SCH_LT_ALLERGY_TOTAL',
            'PUB_SCH_AGG_LT_ALLERGY',
            'PUB_SCH_K3_LT_ALLERGY',
            'PUB_SCH_K4_LT_ALLERGY',
            'PUB_SCH_K_LT_ALLERGY',
            'PUB_SCH_1_LT_ALLERGY',
            'PUB_SCH_2_LT_ALLERGY',
            'PUB_SCH_3_LT_ALLERGY',
            'PUB_SCH_4_LT_ALLERGY',
            'PUB_SCH_5_LT_ALLERGY',
            'PUB_SCH_6_LT_ALLERGY',
            'PUB_SCH_7_LT_ALLERGY',
            'PUB_SCH_8_LT_ALLERGY',
            'PUB_SCH_9_LT_ALLERGY',
            'PUB_SCH_10_LT_ALLERGY',
            'PUB_SCH_11_LT_ALLERGY',
            'PUB_SCH_12_LT_ALLERGY',
        ],
        mecfs: ['PUB_SCH_MECFS_TOTAL'],
    },
    privateSchool: {
        asthma: [
            'PRIV_SCH_ASTHMA_TOTAL',
            'PRIV_SCH_AGG_ASTHMA',
            'PRIV_SCH_K3_ASTHMA',
            'PRIV_SCH_K4_ASTHMA',
            'PRIV_SCH_K_ASTHMA',
            'PRIV_SCH_1_ASTHMA',
            'PRIV_SCH_2_ASTHMA',
            'PRIV_SCH_3_ASTHMA',
            'PRIV_SCH_4_ASTHMA',
            'PRIV_SCH_5_ASTHMA',
            'PRIV_SCH_6_ASTHMA',
            'PRIV_SCH_7_ASTHMA',
            'PRIV_SCH_8_ASTHMA',
            'PRIV_SCH_9_ASTHMA',
            'PRIV_SCH_10_ASTHMA',
            'PRIV_SCH_11_ASTHMA',
            'PRIV_SCH_12_ASTHMA',
        ],
        type1: [
            'PRIV_SCH_TYPE1_TOTAL',
            'PRIV_SCH_AGG_TYPE1',
            'PRIV_SCH_K3_TYPE1',
            'PRIV_SCH_K4_TYPE1',
            'PRIV_SCH_K_TYPE1',
            'PRIV_SCH_1_TYPE1',
            'PRIV_SCH_2_TYPE1',
            'PRIV_SCH_3_TYPE1',
            'PRIV_SCH_4_TYPE1',
            'PRIV_SCH_5_TYPE1',
            'PRIV_SCH_6_TYPE1',
            'PRIV_SCH_7_TYPE1',
            'PRIV_SCH_8_TYPE1',
            'PRIV_SCH_9_TYPE1',
            'PRIV_SCH_10_TYPE1',
            'PRIV_SCH_11_TYPE1',
            'PRIV_SCH_12_TYPE1',
        ],
        type2: [
            'PRIV_SCH_TYPE2_TOTAL',
            'PRIV_SCH_AGG_TYPE2',
            'PRIV_SCH_K3_TYPE2',
            'PRIV_SCH_K4_TYPE2',
            'PRIV_SCH_K_TYPE2',
            'PRIV_SCH_1_TYPE2',
            'PRIV_SCH_2_TYPE2',
            'PRIV_SCH_3_TYPE2',
            'PRIV_SCH_4_TYPE2',
            'PRIV_SCH_5_TYPE2',
            'PRIV_SCH_6_TYPE2',
            'PRIV_SCH_7_TYPE2',
            'PRIV_SCH_8_TYPE2',
            'PRIV_SCH_9_TYPE2',
            'PRIV_SCH_10_TYPE2',
            'PRIV_SCH_11_TYPE2',
            'PRIV_SCH_12_TYPE2',
        ],
        seizure: [
            'PRIV_SCH_SEIZURE_TOTAL',
            'PRIV_SCH_AGG_SEIZURE',
            'PRIV_SCH_K3_SEIZURE',
            'PRIV_SCH_K4_SEIZURE',
            'PRIV_SCH_K_SEIZURE',
            'PRIV_SCH_1_SEIZURE',
            'PRIV_SCH_2_SEIZURE',
            'PRIV_SCH_3_SEIZURE',
            'PRIV_SCH_4_SEIZURE',
            'PRIV_SCH_5_SEIZURE',
            'PRIV_SCH_6_SEIZURE',
            'PRIV_SCH_7_SEIZURE',
            'PRIV_SCH_8_SEIZURE',
            'PRIV_SCH_9_SEIZURE',
            'PRIV_SCH_10_SEIZURE',
            'PRIV_SCH_11_SEIZURE',
            'PRIV_SCH_12_SEIZURE',
        ],
        lta: [
            'PRIV_SCH_LT_ALLERGY_TOTAL',
            'PRIV_SCH_AGG_LT_ALLERGY',
            'PRIV_SCH_K3_LT_ALLERGY',
            'PRIV_SCH_K4_LT_ALLERGY',
            'PRIV_SCH_K_LT_ALLERGY',
            'PRIV_SCH_1_LT_ALLERGY',
            'PRIV_SCH_2_LT_ALLERGY',
            'PRIV_SCH_3_LT_ALLERGY',
            'PRIV_SCH_4_LT_ALLERGY',
            'PRIV_SCH_5_LT_ALLERGY',
            'PRIV_SCH_6_LT_ALLERGY',
            'PRIV_SCH_7_LT_ALLERGY',
            'PRIV_SCH_8_LT_ALLERGY',
            'PRIV_SCH_9_LT_ALLERGY',
            'PRIV_SCH_10_LT_ALLERGY',
            'PRIV_SCH_11_LT_ALLERGY',
            'PRIV_SCH_12_LT_ALLERGY',
        ],
    },
    district: {
        asthma: [
            'DIST_ASTHMA_TOTAL',
            'DIST_AGG_ASTHMA',
            'DIST_K3_ASTHMA',
            'DIST_K4_ASTHMA',
            'DIST_K_ASTHMA',
            'DIST_1_ASTHMA',
            'DIST_2_ASTHMA',
            'DIST_3_ASTHMA',
            'DIST_4_ASTHMA',
            'DIST_5_ASTHMA',
            'DIST_6_ASTHMA',
            'DIST_7_ASTHMA',
            'DIST_8_ASTHMA',
            'DIST_9_ASTHMA',
            'DIST_10_ASTHMA',
            'DIST_11_ASTHMA',
            'DIST_12_ASTHMA',
        ],
        type1: [
            'DIST_TYPE1_TOTAL',
            'DIST_AGG_TYPE1',
            'DIST_K3_TYPE1',
            'DIST_K4_TYPE1',
            'DIST_K_TYPE1',
            'DIST_1_TYPE1',
            'DIST_2_TYPE1',
            'DIST_3_TYPE1',
            'DIST_4_TYPE1',
            'DIST_5_TYPE1',
            'DIST_6_TYPE1',
            'DIST_7_TYPE1',
            'DIST_8_TYPE1',
            'DIST_9_TYPE1',
            'DIST_10_TYPE1',
            'DIST_11_TYPE1',
            'DIST_12_TYPE1',
        ],
        type2: [
            'DIST_TYPE2_TOTAL',
            'DIST_AGG_TYPE2',
            'DIST_K3_TYPE2',
            'DIST_K4_TYPE2',
            'DIST_K_TYPE2',
            'DIST_1_TYPE2',
            'DIST_2_TYPE2',
            'DIST_3_TYPE2',
            'DIST_4_TYPE2',
            'DIST_5_TYPE2',
            'DIST_6_TYPE2',
            'DIST_7_TYPE2',
            'DIST_8_TYPE2',
            'DIST_9_TYPE2',
            'DIST_10_TYPE2',
            'DIST_11_TYPE2',
            'DIST_12_TYPE2',
        ],
        seizure: [
            'DIST_SEIZURE_TOTAL',
            'DIST_AGG_SEIZURE',
            'DIST_K3_SEIZURE',
            'DIST_K4_SEIZURE',
            'DIST_K_SEIZURE',
            'DIST_1_SEIZURE',
            'DIST_2_SEIZURE',
            'DIST_3_SEIZURE',
            'DIST_4_SEIZURE',
            'DIST_5_SEIZURE',
            'DIST_6_SEIZURE',
            'DIST_7_SEIZURE',
            'DIST_8_SEIZURE',
            'DIST_9_SEIZURE',
            'DIST_10_SEIZURE',
            'DIST_11_SEIZURE',
            'DIST_12_SEIZURE',
        ],
        lta: [
            'DIST_LT_ALLERGY_TOTAL',
            'DIST_AGG_LT_ALLERGY',
            'DIST_K3_LT_ALLERGY',
            'DIST_K4_LT_ALLERGY',
            'DIST_K_LT_ALLERGY',
            'DIST_1_LT_ALLERGY',
            'DIST_2_LT_ALLERGY',
            'DIST_3_LT_ALLERGY',
            'DIST_4_LT_ALLERGY',
            'DIST_5_LT_ALLERGY',
            'DIST_6_LT_ALLERGY',
            'DIST_7_LT_ALLERGY',
            'DIST_8_LT_ALLERGY',
            'DIST_9_LT_ALLERGY',
            'DIST_10_LT_ALLERGY',
            'DIST_11_LT_ALLERGY',
            'DIST_12_LT_ALLERGY',
        ],
        mecfs: ['DIST_MECFS_TOTAL'],
    },
    state: {
        asthma: [
            'ST_ASTHMA_TOTAL',
            'ST_AGG_ASTHMA',
            'ST_K3_ASTHMA',
            'ST_K4_ASTHMA',
            'ST_K_ASTHMA',
            'ST_1_ASTHMA',
            'ST_2_ASTHMA',
            'ST_3_ASTHMA',
            'ST_4_ASTHMA',
            'ST_5_ASTHMA',
            'ST_6_ASTHMA',
            'ST_7_ASTHMA',
            'ST_8_ASTHMA',
            'ST_9_ASTHMA',
            'ST_10_ASTHMA',
            'ST_11_ASTHMA',
            'ST_12_ASTHMA',
        ],
        type1: [
            'ST_TYPE1_TOTAL',
            'ST_AGG_TYPE1',
            'ST_K3_TYPE1',
            'ST_K4_TYPE1',
            'ST_K_TYPE1',
            'ST_1_TYPE1',
            'ST_2_TYPE1',
            'ST_3_TYPE1',
            'ST_4_TYPE1',
            'ST_5_TYPE1',
            'ST_6_TYPE1',
            'ST_7_TYPE1',
            'ST_8_TYPE1',
            'ST_9_TYPE1',
            'ST_10_TYPE1',
            'ST_11_TYPE1',
            'ST_12_TYPE1',
        ],
        type2: [
            'ST_TYPE2_TOTAL',
            'ST_AGG_TYPE2',
            'ST_K3_TYPE2',
            'ST_K4_TYPE2',
            'ST_K_TYPE2',
            'ST_1_TYPE2',
            'ST_2_TYPE2',
            'ST_3_TYPE2',
            'ST_4_TYPE2',
            'ST_5_TYPE2',
            'ST_6_TYPE2',
            'ST_7_TYPE2',
            'ST_8_TYPE2',
            'ST_9_TYPE2',
            'ST_10_TYPE2',
            'ST_11_TYPE2',
            'ST_12_TYPE2',
        ],
        seizure: [
            'ST_SEIZURE_TOTAL',
            'ST_AGG_SEIZURE',
            'ST_K3_SEIZURE',
            'ST_K4_SEIZURE',
            'ST_K_SEIZURE',
            'ST_1_SEIZURE',
            'ST_2_SEIZURE',
            'ST_3_SEIZURE',
            'ST_4_SEIZURE',
            'ST_5_SEIZURE',
            'ST_6_SEIZURE',
            'ST_7_SEIZURE',
            'ST_8_SEIZURE',
            'ST_9_SEIZURE',
            'ST_10_SEIZURE',
            'ST_11_SEIZURE',
            'ST_12_SEIZURE',
        ],
        lta: [
            'ST_LT_ALLERGY_TOTAL',
            'ST_AGG_LT_ALLERGY',
            'ST_K3_LT_ALLERGY',
            'ST_K4_LT_ALLERGY',
            'ST_K_LT_ALLERGY',
            'ST_1_LT_ALLERGY',
            'ST_2_LT_ALLERGY',
            'ST_3_LT_ALLERGY',
            'ST_4_LT_ALLERGY',
            'ST_5_LT_ALLERGY',
            'ST_6_LT_ALLERGY',
            'ST_7_LT_ALLERGY',
            'ST_8_LT_ALLERGY',
            'ST_9_LT_ALLERGY',
            'ST_10_LT_ALLERGY',
            'ST_11_LT_ALLERGY',
            'ST_12_LT_ALLERGY',
        ],
        mecfs: ['ST_MECFS_TOTAL'],
    },
    statePrivate: {
        asthma: [
            'ST_PRIV_SCH_ASTHMA_TOTAL',
            'ST_PRIV_SCH_AGG_ASTHMA',
            'ST_PRIV_SCH_K3_ASTHMA',
            'ST_PRIV_SCH_K4_ASTHMA',
            'ST_PRIV_SCH_K_ASTHMA',
            'ST_PRIV_SCH_1_ASTHMA',
            'ST_PRIV_SCH_2_ASTHMA',
            'ST_PRIV_SCH_3_ASTHMA',
            'ST_PRIV_SCH_4_ASTHMA',
            'ST_PRIV_SCH_5_ASTHMA',
            'ST_PRIV_SCH_6_ASTHMA',
            'ST_PRIV_SCH_7_ASTHMA',
            'ST_PRIV_SCH_8_ASTHMA',
            'ST_PRIV_SCH_9_ASTHMA',
            'ST_PRIV_SCH_10_ASTHMA',
            'ST_PRIV_SCH_11_ASTHMA',
            'ST_PRIV_SCH_12_ASTHMA',
        ],
        type1: [
            'ST_PRIV_SCH_TYPE1_TOTAL',
            'ST_PRIV_SCH_AGG_TYPE1',
            'ST_PRIV_SCH_K3_TYPE1',
            'ST_PRIV_SCH_K4_TYPE1',
            'ST_PRIV_SCH_K_TYPE1',
            'ST_PRIV_SCH_1_TYPE1',
            'ST_PRIV_SCH_2_TYPE1',
            'ST_PRIV_SCH_3_TYPE1',
            'ST_PRIV_SCH_4_TYPE1',
            'ST_PRIV_SCH_5_TYPE1',
            'ST_PRIV_SCH_6_TYPE1',
            'ST_PRIV_SCH_7_TYPE1',
            'ST_PRIV_SCH_8_TYPE1',
            'ST_PRIV_SCH_9_TYPE1',
            'ST_PRIV_SCH_10_TYPE1',
            'ST_PRIV_SCH_11_TYPE1',
            'ST_PRIV_SCH_12_TYPE1',
        ],
        type2: [
            'ST_PRIV_SCH_TYPE2_TOTAL',
            'ST_PRIV_SCH_AGG_TYPE2',
            'ST_PRIV_SCH_K3_TYPE2',
            'ST_PRIV_SCH_K4_TYPE2',
            'ST_PRIV_SCH_K_TYPE2',
            'ST_PRIV_SCH_1_TYPE2',
            'ST_PRIV_SCH_2_TYPE2',
            'ST_PRIV_SCH_3_TYPE2',
            'ST_PRIV_SCH_4_TYPE2',
            'ST_PRIV_SCH_5_TYPE2',
            'ST_PRIV_SCH_6_TYPE2',
            'ST_PRIV_SCH_7_TYPE2',
            'ST_PRIV_SCH_8_TYPE2',
            'ST_PRIV_SCH_9_TYPE2',
            'ST_PRIV_SCH_10_TYPE2',
            'ST_PRIV_SCH_11_TYPE2',
            'ST_PRIV_SCH_12_TYPE2',
        ],
        seizure: [
            'ST_PRIV_SCH_SEIZURE_TOTAL',
            'ST_PRIV_SCH_AGG_SEIZURE',
            'ST_PRIV_SCH_K3_SEIZURE',
            'ST_PRIV_SCH_K4_SEIZURE',
            'ST_PRIV_SCH_K_SEIZURE',
            'ST_PRIV_SCH_1_SEIZURE',
            'ST_PRIV_SCH_2_SEIZURE',
            'ST_PRIV_SCH_3_SEIZURE',
            'ST_PRIV_SCH_4_SEIZURE',
            'ST_PRIV_SCH_5_SEIZURE',
            'ST_PRIV_SCH_6_SEIZURE',
            'ST_PRIV_SCH_7_SEIZURE',
            'ST_PRIV_SCH_8_SEIZURE',
            'ST_PRIV_SCH_9_SEIZURE',
            'ST_PRIV_SCH_10_SEIZURE',
            'ST_PRIV_SCH_11_SEIZURE',
            'ST_PRIV_SCH_12_SEIZURE',
        ],
        lta: [
            'ST_PRIV_SCH_LT_ALLERGY_TOTAL',
            'ST_PRIV_SCH_AGG_LT_ALLERGY',
            'ST_PRIV_SCH_K3_LT_ALLERGY',
            'ST_PRIV_SCH_K4_LT_ALLERGY',
            'ST_PRIV_SCH_K_LT_ALLERGY',
            'ST_PRIV_SCH_1_LT_ALLERGY',
            'ST_PRIV_SCH_2_LT_ALLERGY',
            'ST_PRIV_SCH_3_LT_ALLERGY',
            'ST_PRIV_SCH_4_LT_ALLERGY',
            'ST_PRIV_SCH_5_LT_ALLERGY',
            'ST_PRIV_SCH_6_LT_ALLERGY',
            'ST_PRIV_SCH_7_LT_ALLERGY',
            'ST_PRIV_SCH_8_LT_ALLERGY',
            'ST_PRIV_SCH_9_LT_ALLERGY',
            'ST_PRIV_SCH_10_LT_ALLERGY',
            'ST_PRIV_SCH_11_LT_ALLERGY',
            'ST_PRIV_SCH_12_LT_ALLERGY',
        ],
        mecfs: ['ST_PRIV_SCH_MECFS_TOTAL'],
    },
};
